import React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { LeftChevron } from "../../../common/js/icons";

const PageToolbar = styled(Grid)({
    marginBottom: "20px",
    marginTop: "20px",
});

const LeftIcon = styled(Grid)({
    marginLeft: "25px",
});

const ProgressDiv = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
});

const EditTransactionToolbar = (props) => {
    const { newTransaction, elementsSaving, saveTransaction, transaction, history } = props;

    const handleSaveTransaction = async (options) => {
        const isTransactionCreated = await saveTransaction(options);
        if (isTransactionCreated) {
            history.push("/transactions");
        }
    };
    return (
        <PageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item zeroMinWidth style={{ paddingBottom: "2px", paddingRight: "0px" }}>
                <Link to="/transactions">
                    <LeftChevron />
                </Link>
            </Grid>
            <Grid item xs>
                <h2 className="page-title">{newTransaction ? "Create New Transaction" : "Edit Transaction"}</h2>
            </Grid>
            <Grid item xs>
                <Grid container alignItems="center" spacing={0} justifyContent="flex-end">
                    <LeftIcon item>
                        {elementsSaving.saveAndExit ? (
                            <ProgressDiv>
                                <CircularProgress size={20} color="primary" />
                            </ProgressDiv>
                        ) : (
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() =>
                                    handleSaveTransaction({
                                        key: transaction.transactionKey,
                                        complete: false,
                                        buttonClicked: "saveAndExit",
                                    })
                                }
                            >
                                Save & Exit
                            </Button>
                        )}
                        {elementsSaving.submit ? (
                            <ProgressDiv>
                                <CircularProgress size={20} color="primary" />
                            </ProgressDiv>
                        ) : (
                            (newTransaction || transaction.status === "Draft") && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() =>
                                        handleSaveTransaction({
                                            key: transaction.transactionKey,
                                            complete: true,
                                            buttonClicked: "submit",
                                        })
                                    }
                                >
                                    Complete Transaction
                                </Button>
                            )
                        )}
                    </LeftIcon>
                </Grid>
            </Grid>
        </PageToolbar>
    );
};

export default EditTransactionToolbar;
